import { useEffect, useState } from "react";
import dashboardStyle from "../styles/Dashboard.module.css";
import DepositoBancario from "./MetodosDePago/DepositoBancario";
import Efectivo from "./MetodosDePago/Efectivo";
import PagoFacil from "./MetodosDePago/PagoFacil";
import TarjetaDeCredito from "./MetodosDePago/TarjetaDeCredito";
import GoCuotas from "./MetodosDePago/GoCuotas";
import TransferenciaBancaria from "./MetodosDePago/TransferenciaBancaria";
import { useDataContext } from "../contexts/AuthContext";
import { getPaymentInformation } from "../services/api";
import { PaymentModalLoader } from "./MetodosDePago/PaymentReportForm";

const SUPPORTED_METHODS = {
  "Depósito Bancario": DepositoBancario,
  Efectivo,
  PagoFácil: PagoFacil,
  "Tarjeta de crédito": TarjetaDeCredito,
  "GO CUOTAS": GoCuotas,
  "Transferencia Bancaria": TransferenciaBancaria,
};

function Modal3({ toggleModal3, onFormularioEnviado }) {
  const { contextData } = useDataContext();
  const customerId = contextData?.customer?.id;
  const orderId = contextData?.customer?.order_id;

  const [paymentMethod, setPaymentMethod] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!customerId || !orderId) {
      setLoading(false);
      return;
    }

    let ignore = false;
    setLoading(true);

    getPaymentInformation(customerId, orderId)
      .then((data) => {
        if (!ignore) {
          setPaymentMethod(data?.payment_method || "");
        }
      })
      .catch((error) => {
        console.log(error.message);
        if (!ignore) {
          setPaymentMethod("");
        }
      })
      .finally(() => {
        if (!ignore) {
          setLoading(false);
        }
      });

    return () => {
      ignore = true;
    };
  }, [customerId, orderId]);

  const ActiveMethodComponent = paymentMethod
    ? SUPPORTED_METHODS[paymentMethod]
    : null;

  return (
    <div className={dashboardStyle.modalBackground}>
      <div className={dashboardStyle.modal}>
        <div className={dashboardStyle.modalHeader}>
          <button
            type="button"
            className={dashboardStyle.modalBackBtn}
            onClick={toggleModal3}
          >
            <span aria-hidden="true">←</span> Volver
          </button>
          <span className={dashboardStyle.modalStep}>Informe de pago</span>
          <h2 className={dashboardStyle.modalTitle}>
            Informar <span className={dashboardStyle.modalTitleAccent}>pago</span>
          </h2>
          <p className={dashboardStyle.modalSubtitle}>
            Cargá los datos del pago y el comprobante para que podamos revisarlo sin
            confusiones.
          </p>
        </div>

        {loading ? <PaymentModalLoader /> : null}

        {!loading && ActiveMethodComponent ? (
          <ActiveMethodComponent
            toggleModal3={toggleModal3}
            onFormularioEnviado={onFormularioEnviado}
          />
        ) : null}

        {!loading && !ActiveMethodComponent ? (
          <div className={dashboardStyle.paymentModalEmpty}>
            <i className="bi bi-info-circle" aria-hidden="true" />
            <p>
              No encontramos un formulario disponible para el método de pago actual.
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Modal3;
